(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return componentQuantitySelector$1; }), Promise.resolve().then(function () { return componentCartItems$1; }), Promise.resolve().then(function () { return cartMismatchedDate$1; }), Promise.resolve().then(function () { return cartOutOfStockProduct$1; }), Promise.resolve().then(function () { return cartProductGift; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    const {
      getElementByRef: getElementByRef$5
    } = window.PoleneLibs.Refs;
    const {
      QuantitySelectorUpdateEvent
    } = window.PoleneLibs.CartEvents;
    class ComponentQuantitySelector extends HTMLElement {
      quantityInput = null;
      valueOnFocus = null;
      increaseButton = null;
      decreaseButton = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
        this.attachEventListeners();
      }
      updatedCallback() {
        this.removeEventListeners();
        this.init();
        this.attachEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      init() {
        const {
          quantityInput,
          increaseButton,
          decreaseButton
        } = getElementByRef$5(['quantity-input', 'increase-button', 'decrease-button'], this);
        if (quantityInput instanceof HTMLInputElement) {
          this.quantityInput = quantityInput;
        }
        if (increaseButton instanceof HTMLButtonElement) {
          this.increaseButton = increaseButton;
        }
        if (decreaseButton instanceof HTMLButtonElement) {
          this.decreaseButton = decreaseButton;
        }
        if (!this.quantityInput) {
          return;
        }
      }
      attachEventListeners() {
        this.increaseButton?.addEventListener('click', this.handleIncreaseClick);
        this.decreaseButton?.addEventListener('click', this.handleDecreaseClick);
        this.quantityInput?.addEventListener('blur', this.handleBlur);
        this.quantityInput?.addEventListener('focus', this.handleFocus);
        this.quantityInput?.addEventListener('keydown', this.handleKeydown);
      }
      removeEventListeners() {
        this.increaseButton?.removeEventListener('click', this.handleIncreaseClick);
        this.decreaseButton?.removeEventListener('click', this.handleDecreaseClick);
        this.quantityInput?.removeEventListener('blur', this.handleBlur);
        this.quantityInput?.removeEventListener('focus', this.handleFocus);
        this.quantityInput?.removeEventListener('keydown', this.handleKeydown);
      }
      handleIncreaseClick = event => {
        if (!(event.target instanceof HTMLElement)) return;
        event.preventDefault();
        if (!this.quantityInput) return;
        this.quantityInput.stepUp();
        this.onQuantityChange();
      };
      handleDecreaseClick = event => {
        if (!(event.target instanceof HTMLElement)) return;
        event.preventDefault();
        if (!this.quantityInput) return;
        this.quantityInput.stepDown();
        this.onQuantityChange();
      };
      handleFocus = event => {
        if (!this.quantityInput) return;
        if (!(event.target instanceof HTMLInputElement)) return;
        this.valueOnFocus = this.quantityInput.value;
        if (document.activeElement !== this.quantityInput) return;
        this.quantityInput.select();
      };
      handleKeydown = event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.quantityInput?.blur();
        }
      };
      handleBlur = event => {
        if (!(event.target instanceof HTMLElement)) return;
        event.preventDefault();
        if (event.target instanceof HTMLInputElement && this.quantityInput) {
          this.quantityInput.value = event.target.value;
        }
        if (this.quantityInput?.value === this.valueOnFocus) return;
        this.onQuantityChange();
      };
      onQuantityChange() {
        if (!this.quantityInput) return;
        this.checkQuantityRules();
        const newValue = parseInt(this.quantityInput.value, 10);
        const cartLine = this.quantityInput.dataset.cartLine ? Number(this.quantityInput.dataset.cartLine) : undefined;
        if (newValue == 0) {
          this.quantityInput.value = '1';
          return;
        }
        this.quantityInput.dispatchEvent(new QuantitySelectorUpdateEvent(newValue, cartLine));
      }
      checkQuantityRules() {
        if (!this.quantityInput) return;
        const {
          min,
          max,
          value: currentValue
        } = this.quantityInput;
        const newValue = parseInt(currentValue, 10);
        if (min && newValue < parseInt(min, 10)) {
          this.quantityInput.value = min;
        }
        if (max && newValue > parseInt(max, 10)) {
          this.quantityInput.value = max;
        }
      }
      static define() {
        if (!customElements.get('component-quantity-selector')) {
          customElements.define('component-quantity-selector', ComponentQuantitySelector);
        }
      }
    }
    var componentQuantitySelector = () => {
      ComponentQuantitySelector.define();
    };

    var componentQuantitySelector$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentQuantitySelector
    });

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const TIMEOUTS = {
      DELAY_50: 50,
      DELAY_150: 150,
      COMMON_DELAY_300: 300,
      DELAY_500: 500,
      DELAY_600: 600,
      DELAY_4000: 4000
    };
    const MIXPANEL_BRIDGE_KEY = 'mixpanel:bridge';
    const MIXPANEL_BRIDGE_VERSION = 1;
    const ATC_SOURCE_MAX_AGE = 60000;
    const ATC_SOURCE_FALLBACK = 'unknown';

    const isPlainObject = value => typeof value === 'object' && value !== null && !Array.isArray(value);
    const normalizeVariantId = variantId => {
      const digits = String(variantId ?? '').match(/\d+/g);
      return digits ? digits[digits.length - 1] : null;
    };
    const persist = (merged, fresh) => {
      try {
        sessionStorage.setItem(MIXPANEL_BRIDGE_KEY, JSON.stringify({
          v: MIXPANEL_BRIDGE_VERSION,
          ...merged
        }));
      } catch {
        try {
          sessionStorage.removeItem(MIXPANEL_BRIDGE_KEY);
          sessionStorage.setItem(MIXPANEL_BRIDGE_KEY, JSON.stringify({
            v: MIXPANEL_BRIDGE_VERSION,
            ...fresh
          }));
        } catch {
          return;
        }
      }
    };
    const readBridge = () => {
      try {
        const raw = sessionStorage.getItem(MIXPANEL_BRIDGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return isPlainObject(parsed) ? parsed : {};
      } catch {
        return {};
      }
    };
    const recordAtcSources = (variantIds, source) => {
      const ids = variantIds.map(normalizeVariantId).filter(id => id !== null);
      if (!ids.length) return;
      const now = Date.now();
      const fresh = {};
      ids.forEach(id => {
        fresh[id] = {
          source,
          ts: now
        };
      });
      const bridge = readBridge();
      const stored = isPlainObject(bridge.atc_sources) ? bridge.atc_sources : {};
      const kept = {};
      Object.entries(stored).forEach(([id, entry]) => {
        if (!isPlainObject(entry)) return;
        const {
          source: entrySource,
          ts
        } = entry;
        if (typeof entrySource !== 'string' || typeof ts !== 'number') return;
        if (now - ts > ATC_SOURCE_MAX_AGE) return;
        kept[id] = {
          source: entrySource,
          ts
        };
      });
      persist({
        ...bridge,
        atc_sources: {
          ...kept,
          ...fresh
        }
      }, {
        atc_sources: fresh
      });
    };

    window.PoleneLibs.ElementTemplates;
    const events$1 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$1,
      parseProductForm
    } = window.PoleneLibs.Utils;
    const {
      getRefs,
      getElementByRef: getElementByRef$4
    } = window.PoleneLibs.Refs;
    const {
      morphSection
    } = window.PoleneLibs.SectionRenderer;
    const {
      dispatchCartError: dispatchCartError$1,
      cartErrorMessage: cartErrorMessage$1
    } = window.PoleneLibs.CartEvents;
    const root = window.Shopify?.routes.root;
    const selectors = {
      cartCounter: '.js-cart-counter',
      variantInput: '.js-variant-input'
    };
    const addToCart = async (lineItems, source = ATC_SOURCE_FALLBACK) => {
      try {
        const cartComponent = document.querySelector('component-cart-items');
        const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
        const lineItemIds = Array.isArray(lineItems?.items) ? lineItems.items.map(item => item?.id) : [lineItems?.id];
        recordAtcSources(lineItemIds, source);
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            ...lineItems,
            sections: sectionId
          })
        });
        const json = await response.json().catch(() => null);
        if (!response.ok) {
          dispatchCartError$1({
            endpoint: 'cart/add.js',
            method: 'POST',
            status: response.status,
            message: cartErrorMessage$1(json)
          });
          return {
            errors: json?.description || json?.message || 'Failed to add to cart'
          };
        }
        if (json.sections?.[sectionId]) {
          await updateCartContent(json.sections[sectionId], json);
        }
        return json;
      } catch (error) {
        dispatchCartError$1({
          endpoint: 'cart/add.js',
          method: 'POST',
          status: null,
          message: cartErrorMessage$1(error)
        });
        return {
          errors: 'Failed to add to cart'
        };
      }
    };
    const changeCart = async (identifier, quantity) => {
      try {
        const cartComponent = document.querySelector('component-cart-items');
        const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
        const cartIdentifier = typeof identifier === 'number' ? {
          line: identifier
        } : identifier;
        const response = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            ...cartIdentifier,
            quantity,
            sections: sectionId
          })
        });
        const json = await response.json().catch(() => null);
        if (response.ok && json && 'sections' in json) {
          await updateCartContent(json.sections[sectionId], json);
          return json;
        }
        if (!response.ok) {
          dispatchCartError$1({
            endpoint: 'cart/change.js',
            method: 'POST',
            status: response.status,
            message: cartErrorMessage$1(json)
          });
          return {
            errors: json?.description || json?.message || 'Failed to update cart'
          };
        }
        return json;
      } catch (error) {
        dispatchCartError$1({
          endpoint: 'cart/change.js',
          method: 'POST',
          status: null,
          message: cartErrorMessage$1(error)
        });
        return {
          errors: 'Failed to update cart'
        };
      }
    };
    const updateCartItemProperties = async ({
      lineItemKey,
      quantity,
      properties
    }) => {
      let status = null;
      try {
        const response = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: quantity,
            properties: properties
          })
        });
        if (!response.ok) {
          status = response.status;
          throw Error('Error while updating cart properties');
        }
        return await response.json();
      } catch (error) {
        dispatchCartError$1({
          endpoint: 'cart/change.js',
          method: 'POST',
          status,
          message: status ? `HTTP ${status}` : cartErrorMessage$1(error)
        });
        throw Error('Error while updating cart properties:' + error);
      }
    };
    const updateCartContent = async (section, json) => {
      try {
        const cartComponent = document.querySelector('component-cart-items');
        const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
        await morphSection(sectionId, section);
        dispatchEvent$1(window, events$1.CART_UPDATED, json);
        dispatchEvent$1(window, events$1.CART_DOM_UPDATED);
      } catch (error) {
        const {
          cart
        } = getRefs();
        if (cart) {
          cart.innerHTML = section;
          setCartCount(0);
        }
      }
    };
    const setCartCount = amount => {
      const counters = document.querySelectorAll(selectors.cartCounter);
      counters.forEach(counter => {
        const currentText = counter.innerHTML;
        const newText = counter.classList.contains('visually-hidden') ? currentText.replace(/\d+/, amount.toString()) : amount.toString();
        counter.innerHTML = newText;
      });
    };

    const {
      getElementByRef: getElementByRef$3
    } = window.PoleneLibs.Refs;
    const {
      CartUpdateEvent,
      dispatchCartError,
      cartErrorMessage
    } = window.PoleneLibs.CartEvents;
    const {
      debounce: debounce$1,
      prefersReducedMotion,
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const Events = window.PoleneLibs.Events.default;
    class ComponentCartItems extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.attachEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      attachEventListeners() {
        document.addEventListener(Events.QUANTITY_SELECTOR_UPDATE, this.handleQuantityChange);
        document.addEventListener(Events.CART_LINE_ITEM_UPDATE, this.handleCartUpdate);
        this.addEventListener('click', this.handleRemoveClick);
        const giftCheckbox = this.querySelector('.cart-gift__label input[type="checkbox"]');
        if (giftCheckbox) {
          giftCheckbox.addEventListener('change', this.handleGiftCheckboxChange);
        }
      }
      removeEventListeners() {
        document.removeEventListener(Events.QUANTITY_SELECTOR_UPDATE, this.handleQuantityChange);
        document.removeEventListener(Events.CART_LINE_ITEM_UPDATE, this.handleCartUpdate);
        this.removeEventListener('click', this.handleRemoveClick);
        const giftCheckbox = this.querySelector('.cart-gift__label input[type="checkbox"]');
        if (giftCheckbox) {
          giftCheckbox.removeEventListener('change', this.handleGiftCheckboxChange);
        }
      }
      handleRemoveClick = event => {
        const target = event.target;
        const removeButton = target.closest('[data-ref="remove-button"]');
        if (!removeButton) return;
        const cartItemRow = removeButton.closest('[data-ref="cart-item-rows"]');
        if (!cartItemRow) return;
        const allCartItemRows = Array.from(this.querySelectorAll('[data-ref="cart-item-rows"]'));
        const line = allCartItemRows.indexOf(cartItemRow) + 1;
        if (line > 0) {
          cartItemRow.querySelector('component-modal')?.close();
          this.onLineItemRemove(line, cartItemRow.dataset.key);
        }
      };
      handleQuantityChange = debounce$1(event => {
        if (!(event instanceof CustomEvent)) return;
        const {
          quantity,
          cartLine: line
        } = event.detail;
        if (!line) return;
        if (quantity === 0) {
          return this.onLineItemRemove(line);
        }
        this.updateQuantity({
          line,
          quantity,
          action: 'change'
        });
      }, 300);
      handleGiftCheckboxChange = async event => {
        const checkbox = event.target;
        const attributeName = checkbox.name.match(/attributes\[(.*?)\]/)?.[1];
        if (!attributeName) return;
        this.disableCartItems();
        try {
          const attributes = {};
          attributes[attributeName] = checkbox.checked ? 'Yes' : '';
          const response = await fetch(`${window.Shopify?.routes.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              attributes
            })
          });
          if (!response.ok) {
            dispatchCartError({
              endpoint: 'cart/update.js',
              method: 'POST',
              status: response.status,
              message: `HTTP ${response.status}`
            });
            throw new Error('Failed to update cart attributes');
          }
        } catch (error) {
          if (!(error instanceof Error && error.message === 'Failed to update cart attributes')) {
            dispatchCartError({
              endpoint: 'cart/update.js',
              method: 'POST',
              status: null,
              message: cartErrorMessage(error)
            });
          }
          checkbox.checked = !checkbox.checked;
        } finally {
          this.enableCartItems();
        }
      };
      onLineItemRemove(line, id) {
        this.updateQuantity({
          line,
          quantity: 0,
          action: 'clear',
          id
        });
        const allCartItemRows = Array.from(this.querySelectorAll('[data-ref="cart-item-rows"]'));
        const cartItemRowToRemove = allCartItemRows[line - 1];
        if (!cartItemRowToRemove) return;
        const rowsToRemove = [cartItemRowToRemove, ...allCartItemRows.filter(row => row.dataset.parentKey === cartItemRowToRemove.dataset.key)];
        rowsToRemove.forEach(row => {
          const remove = () => row.remove();
          if (prefersReducedMotion()) return remove();
          row.style.setProperty('--row-height', `${row.clientHeight}px`);
          row.classList.add('removing');
        });
      }
      async updateQuantity(config) {
        this.disableCartItems();
        const {
          line,
          quantity,
          id
        } = config;
        try {
          const response = await changeCart(id ? {
            id
          } : line, quantity);
          if (response && 'sections' in response) {
            const newCartHiddenItemCount = this.querySelector('[data-ref="cart-item-count"]')?.textContent;
            const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;
            this.dispatchEvent(new CartUpdateEvent({
              itemCount: newCartItemCount,
              source: 'cart-items-component',
              sections: response.sections
            }));
            dispatchEvent(window, Events.CART_DOM_UPDATED);
          }
          if (response && 'errors' in response) {
            this.handleCartError(line, response.errors);
          }
        } catch (error) {} finally {
          this.enableCartItems();
        }
      }
      handleCartError = (line, error) => {
        const allQuantitySelectors = Array.from(this.querySelectorAll('[data-ref="quantity-selectors"]'));
        const quantitySelector = allQuantitySelectors[line - 1];
        const quantityInput = quantitySelector?.querySelector('input');
        if (quantityInput) {
          quantityInput.value = quantityInput.defaultValue;
        }
        const {
          [`cartItemError-${line}`]: cartItemError,
          [`cartItemErrorContainer-${line}`]: cartItemErrorContainer
        } = getElementByRef$3([`cartItemError-${line}`, `cartItemErrorContainer-${line}`], this);
        if (!(cartItemError instanceof HTMLElement) || !(cartItemErrorContainer instanceof HTMLElement)) {
          return;
        }
        cartItemError.textContent = error;
        cartItemErrorContainer.classList.remove('hidden');
      };
      handleCartUpdate = event => {
        if (event.target === this) return;
        dispatchEvent(window, Events.CART_DOM_UPDATED);
      };
      disableCartItems() {
        this.classList.add('cart-items-disabled');
      }
      enableCartItems() {
        this.classList.remove('cart-items-disabled');
      }
      get sectionId() {
        const {
          sectionId
        } = this.dataset;
        if (!sectionId) {
          return '';
        }
        return sectionId;
      }
      static define() {
        if (!customElements.get('component-cart-items')) {
          customElements.define('component-cart-items', ComponentCartItems);
        }
      }
    }
    var componentCartItems = () => {
      ComponentCartItems.define();
    };

    var componentCartItems$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentCartItems
    });

    const parseCartLineItems = ({
      lineItems
    }) => {
      return lineItems.map(item => {
        const id = item.dataset.id;
        const key = item.dataset.key;
        const quantity = item.dataset.quantity ? parseInt(item.dataset.quantity) : null;
        if (!id || !key || !quantity) {
          throw new Error(`Invalid line item data: missing required attributes`);
        }
        return {
          id,
          key,
          quantity,
          isPreorder: item.dataset.isPreorder === 'true' ? true : false,
          preorderDate: item.dataset.preorderDate,
          formattedPreorderPrefix: item?.dataset?.formattedPreorderPrefix,
          formattedPreorderDate: item?.dataset?.formattedPreorderDate
        };
      });
    };

    const {
      getElementsByRef: getElementsByRef$1,
      getElementByRef: getElementByRef$2
    } = window.PoleneLibs.Refs;
    class CartMismatchedDate {
      cartBanner = null;
      lineItems = [];
      constructor({
        cartBannerElement
      }) {
        try {
          this.cartBanner = cartBannerElement;
          if (!this.cartBanner) {
            throw new Error('Cart banner element not found in the DOM');
          }
          const {
            lineItems
          } = getElementsByRef$1(['line-items'], this.cartBanner);
          if (lineItems) {
            this.lineItems = parseCartLineItems({
              lineItems: Array.isArray(lineItems) ? lineItems : [lineItems]
            });
          }
        } catch (error) {}
        this.updateMismatchedDate();
      }
      async updateMismatchedDate() {
        if (this.lineItems.length !== 0) {
          try {
            await Promise.all(this.lineItems.map(async item => {
              try {
                const properties = !item.isPreorder ? {
                  _is_preorder: 'false'
                } : item.preorderDate && item.formattedPreorderPrefix && item.formattedPreorderDate ? {
                  [item.formattedPreorderPrefix]: item.formattedPreorderDate,
                  _is_preorder: 'true',
                  _preorder_date: item.preorderDate
                } : {
                  _is_preorder: 'false'
                };
                await updateCartItemProperties({
                  lineItemKey: item.key,
                  quantity: item.quantity,
                  properties: properties
                });
              } catch (error) {
                throw new Error('Error updating cart item properties: ' + error);
              }
            }));
          } catch (error) {}
        }
      }
    }
    var cartMismatchedDate = async () => {
      const {
        mismatchedBanner
      } = getElementByRef$2(['mismatched-banner']);
      if (mismatchedBanner) {
        try {
          new CartMismatchedDate({
            cartBannerElement: mismatchedBanner
          });
        } catch (error) {}
      }
    };

    var cartMismatchedDate$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: cartMismatchedDate
    });

    const {
      getElementsByRef,
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    class CartOutOfStockProduct {
      cartBanner = null;
      lineItems = [];
      constructor({
        cartBannerElement
      }) {
        try {
          this.cartBanner = cartBannerElement;
          if (!this.cartBanner) {
            throw new Error('Cart banner element not found in the DOM');
          }
          const {
            lineItems
          } = getElementsByRef(['line-items'], this.cartBanner);
          if (lineItems) {
            this.lineItems = parseCartLineItems({
              lineItems: Array.isArray(lineItems) ? lineItems : [lineItems]
            });
          }
        } catch (error) {}
        this.removeOutOfStockProducts();
      }
      async removeOutOfStockProducts() {
        if (this.lineItems.length !== 0) {
          try {
            await Promise.all(this.lineItems.map(async item => {
              await changeCart({
                id: item.key
              }, 0);
            }));
          } catch (error) {}
        }
      }
    }
    var cartOutOfStockProduct = async () => {
      const {
        oosBanner
      } = getElementByRef$1(['oos-banner']);
      if (oosBanner) {
        try {
          new CartOutOfStockProduct({
            cartBannerElement: oosBanner
          });
        } catch (error) {}
      }
    };

    var cartOutOfStockProduct$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: cartOutOfStockProduct
    });

    const events = window.PoleneLibs.Events.default;
    const {
      getElementByRef
    } = window.PoleneLibs.Refs;
    const {
      debounce
    } = window.PoleneLibs.Utils;
    const CartProductGiftModule = () => {
      const {
        cart
      } = getElementByRef('cart');
      if (!cart?.dataset.productGift || !cart?.dataset.productGiftMinAmount) return;
      const productGift = cart.dataset.productGift;
      const productGiftMinAmount = +cart.dataset.productGiftMinAmount;
      const productGiftPrice = !!cart.dataset.productGiftPrice ? +cart.dataset.productGiftPrice : 0;
      const init = async () => {
        if (window.P1?.cart) await processCartGift(window.P1.cart);
        window.addEventListener(events.CART_FETCHED, debouncedHandleCartGift);
      };
      const cartIsEligibleToProductGift = ({
        productGiftMinAmount,
        productGiftPrice,
        cartAmount
      }) => {
        return productGiftMinAmount * 100 <= cartAmount - productGiftPrice;
      };
      const getCartSectionId = () => {
        const cartComponent = document.querySelector('component-cart-items');
        return cartComponent?.getAttribute('data-section-id') || 'main-cart';
      };
      const addProductGiftToCart = async productGiftId => {
        const cartJson = await addToCart({
          id: productGiftId
        }, 'product_gift');
        if (cartJson) {
          const sectionId = getCartSectionId();
          await updateCartContent(cartJson.sections[sectionId], cartJson);
        }
      };
      const processCartGift = async cartDetails => {
        if (typeof cartDetails?.total_price !== 'number' || !cartDetails?.items) return;
        if (!productGift || !productGiftMinAmount) return;
        const isEligible = cartIsEligibleToProductGift({
          productGiftMinAmount: productGiftMinAmount,
          cartAmount: cartDetails.total_price,
          productGiftPrice: productGiftPrice
        });
        const alreadyInCart = cartDetails.items.some(item => String(item.id) === String(productGift));
        if (isEligible) {
          if (!alreadyInCart) await addProductGiftToCart(productGift);
        } else if (alreadyInCart) {
          await changeCart({
            id: productGift
          }, 0);
        }
      };
      const handleCartGift = async event => {
        const customEvent = event;
        const cartDetails = customEvent?.detail;
        await processCartGift(cartDetails);
      };
      const debouncedHandleCartGift = debounce(handleCartGift, TIMEOUTS.DELAY_500);
      init();
      return () => {
        window.removeEventListener(events.CART_FETCHED, debouncedHandleCartGift);
      };
    };

    var cartProductGift = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CartProductGiftModule: CartProductGiftModule,
        default: CartProductGiftModule
    });

})();
